import { Col, DatePicker, Input, Row, Select, Spin } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import { IoMdClose, IoMdDownload } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import apiFactory from "../../api";
import { GeneralModal } from "../../components/modal/GeneralModal";
import StorageFile from "../../components/preview/StorageFile";
import { STORAGE } from "../../config/Constant";
import { useStorageContext } from "../../context/StorageContext";
import { useInfoUser } from "../../store/UserStore";
import { useGlobalDownloader } from '../../context/global/DownloadProvider';
dayjs.extend(utc);
const { RangePicker } = DatePicker;

const locationTypeList = [
  {
    value: "CONVERSATION",
    label: "Chat",
  },
  {
    value: "NOTIFICATION",
    label: "Mail",
  },
  // {
  //   value: "PROJECT",
  //   label: "Project",
  // },
];

const dateTypeList = [
  {
    value: "DATE",
    label: "Date",
  },
  {
    value: "RANGE",
    label: "Range",
  },
];

const StorageList = () => {
  const { resourceList, initResourceList } = useStorageContext();

  // 1. Dùng useGlobalDownloader
  const { startDownloadCompress } = useGlobalDownloader();
  const { languageMap } = useInfoUser();

  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [pickedList, setPickedList] = useState([]);

  const pickFile = (resourceAccessId) => {
    if (!resourceAccessId) return;

    if (pickedList?.includes(resourceAccessId)) {
      setPickedList(pickedList.filter((id) => id !== resourceAccessId));
    } else {
      setPickedList([...pickedList, resourceAccessId]);
    }
  };

  const deleteStorageFiles = async () => {
    const result = await apiFactory.resourceApi.deleteStorage({
      resourceAccessIds: pickedList,
    });

    if (result?.status !== 200) {
      return;
    }

    setPickedList([]);
    await initResourceList();
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    let downloadResourceIds = [];

    resourceList.forEach((resource) => {
      if (pickedList?.includes(resource?.resourceAccessId)) {
        downloadResourceIds.push(resource?.resourceId);
      }
    });

    // 2. Tự động lưu tên file khi tải nén
    startDownloadCompress(downloadResourceIds, "willo.zip");
  };

  // 3. Đã gỡ bỏ useEffect tự động gọi saveFile()

  return (
    <div className="w-[100%] px-[25px]">
      {pickedList?.length > 0 ? (
        <div className="flex gap-[20px] mb-[5px] bg-[#f0f4f9] p-[5px] rounded-[10px]">
          <button onClick={() => setPickedList([])}>
            <IoMdClose className="text-[18px] text-[#2b9853]" />
          </button>
          <div>
            {pickedList?.length}{" "}
            {languageMap?.["storage.selected"] ?? "Selected"}{" "}
          </div>
          <button onClick={() => setIsOpenModalDelete(true)}>
            <RiDeleteBin6Line className="text-[18px] text-[red]" />
          </button>
          <button onClick={handleDownload}>
            <IoMdDownload className="text-[20px] text-[#2b9853]" />
          </button>
        </div>
      ) : (
        <div className="h-[36px]"></div>
      )}
      <Row>
        {resourceList?.map((item, index) => {
          if (index % 5 === 4) {
            return (
              <Col
                key={item?.uid ?? index}
                xs={24}
                sm={24}
                md={12}
                lg={8}
                xl={6}
                xxl={4}
                className="flex justify-center py-[2px]"
              >
                <StorageFile
                  file={item}
                  pickFile={pickFile}
                  pickedList={pickedList}
                  setPickedList={setPickedList}
                />
              </Col>
            );
          }

          return (
            <>
              <Col
                key={item?.uid ?? index}
                xs={24}
                sm={24}
                md={12}
                lg={8}
                xl={6}
                xxl={4}
                className="flex justify-center py-[2px]"
              >
                <StorageFile
                  file={item}
                  pickFile={pickFile}
                  pickedList={pickedList}
                  setPickedList={setPickedList}
                />
              </Col>
              <Col xs={0} sm={0} md={0} lg={0} xl={0} xxl={1} />
            </>
          );
        })}
      </Row>
      {isOpenModalDelete && (
        <GeneralModal
          title={
            languageMap?.["modal.confirm.titleDeleteFiles"] ??
            "Do you want to delete the selected files?"
          }
          content={
            languageMap?.["modal.confirm.contentDeleteFiles"] ??
            "Once deleted, the files will be gone permanently."
          }
          open={isOpenModalDelete}
          onConfirm={deleteStorageFiles}
          onCancel={() => setIsOpenModalDelete(false)}
        />
      )}
    </div>
  );
};
const Storage = () => {
  const {
    storageSearch,
    setStorageSearch,
    pagination,
    resetPagination,
    viewMore,
    onChangeSearch,
    isLoading,
    onChangeDateType,
    mediaTypes,
  } = useStorageContext();
  const { languageMap } = useInfoUser();

  return (
    <div className="flex flex-col items-center overflow-auto h-full">
      {/* <Button
        className="bg-[#e8f2fc] text-[#2a56b9] border-0 rounded-[50%] absolute top-[10px] right-[70px]"
        icon={<IoChatbubbleEllipsesSharp className="text-[25px]" />}
      /> */}
      <div className="text-[23px] mt-[50px] mb-[25px]">
        {languageMap?.["storage.title.welcome"] ?? "Welcome to Storage"}
      </div>
      <Input
        placeholder={
          languageMap?.["storage.search.placeHolder"] ?? "Search in Storage"
        }
        className="w-[50%] h-[50px] rounded-[30px] text-[18px] mb-[15px]"
        prefix={<IoSearchOutline size={18} />}
        allowClear
        value={storageSearch?.fileName}
        onChange={onChangeSearch}
      />
      <div className="flex gap-[10px]">
        <Select
          // disabled
          options={mediaTypes}
          className="w-[140px] rounded-[30px] text-[18px]"
          placeholder={
            languageMap?.["storage.combobox.mediaType"] ?? "Media type"
          }
          value={storageSearch?.mediaType}
          allowClear
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            resetPagination();
            setStorageSearch((prev) => ({
              ...prev,
              mediaType: value,
            }));
          }}
        />
        <Select
          allowClear
          options={locationTypeList}
          className="w-[140px] rounded-[30px] text-[18px]"
          placeholder={
            languageMap?.["storage.combobox.locationType"] ?? "Location type"
          }
          value={storageSearch?.conversationType}
          onChange={(value) => {
            resetPagination();
            setStorageSearch((prev) => ({
              ...prev,
              conversationType: value,
            }));
          }}
        />
        <Select
          allowClear
          options={dateTypeList}
          className="w-[140px] rounded-[30px] text-[18px]"
          placeholder={
            languageMap?.["storage.combobox.dateType"] ?? "Date type"
          }
          value={storageSearch?.dateType}
          onChange={onChangeDateType}
        />

        {storageSearch?.dateType === "DATE" && (
          <DatePicker
            needConfirm={false}
            format="YYYY-MM-DD"
            className="w-[140px] mb-[5px] text-[18px]"
            value={storageSearch?.selectedDate}
            onChange={(value) => {
              resetPagination();
              setStorageSearch((prev) => ({
                ...prev,
                selectedDate: value,
              }));
            }}
          />
        )}
        {storageSearch?.dateType === "RANGE" && (
          <RangePicker
            className="h-[32px] text-[18px]"
            onChange={(value) => {
              resetPagination();
              setStorageSearch((prev) => ({
                ...prev,
                fromDate: value?.[0] || null,
                toDate: value?.[1] || null,
              }));
            }}
          />
        )}
      </div>
      {!isLoading ? (
        <div className="text-[20px] py-[25px]">
          {Math.min(
            pagination?.page * STORAGE.STORAGE_LIMIT,
            pagination?.total
          )}
          /{pagination?.total}
        </div>
      ) : (
        <Spin className="h-[30px] py-[25px]" />
      )}
      <StorageList />
      {pagination?.page * STORAGE.STORAGE_LIMIT < pagination?.total && (
        <button
          className="text-[18px] mt-[50px] mb-[25px] text-[blue] underline"
          onClick={viewMore}
        >
          {languageMap?.["storage.viewMore"] ?? "View more"}
        </button>
      )}
    </div>
  );
};

export { Storage };

